import React from 'react';
import CardGroup from '../common/CardGroup';
import { useAppContext } from '../../libs/contextLib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMapMarkerAlt, faCalendarAlt, faTicketAlt, faUser, faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './AccountLayout.css';

function getInitials(name, lastname) {
  if (!name && !lastname) return '';
  if (name && lastname) return `${name[0]}${lastname[0]}`.toUpperCase();
  return (name || lastname || '').slice(0, 2).toUpperCase();
}

function Avatar({ initials, icon, image, size = 64 }) {
  return (
    <div className="account-avatar" style={{ width: size, height: size, fontSize: size * 0.36, background: 'linear-gradient(135deg, #cb0f7e 0%, #ff6a00 100%)' }}>
      {image ? (
        <img src={image} alt="avatar" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
      ) : icon ? (
        <span className="account-avatar-icon">{icon}</span>
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}

export default function AccountLayout({
  user: userProp,
  selected = 'orders',
  onNav,
  children
}) {
  const { session } = useAppContext();
  const user = userProp || session?.user || {};
  const initials = getInitials(user.firstname || user.fullname?.split(' ')[0], user.lastname || user.fullname?.split(' ')[1]);
  return (
    <div className="account-layout">
      <div className="account-layout-left">
        <h1>Mi Cuenta</h1>
        <CardGroup className="account-user-card">
          <div className="account-user-card-row1">
            <Avatar initials={initials} size={64} />
            <div className="account-user-card-maininfo">
              <div className="account-user-name">{user.fullname || `${user.firstname || ''} ${user.lastname || ''}`}</div>
              <div className="account-user-email">{user.email}</div>
            </div>
          </div>
          {user.phone && <div className="account-user-info"><FontAwesomeIcon icon={faPhone} /> {user.phone}</div>}
          {user.country && <div className="account-user-info"><FontAwesomeIcon icon={faMapMarkerAlt} /> {user.country}</div>}
          {user.createdAt && <div className="account-user-info"><FontAwesomeIcon icon={faCalendarAlt} /> Miembro desde {new Date(user.createdAt).toLocaleString('es-ES', { month: 'long', year: 'numeric' })}</div>}
        </CardGroup>
        <div className="account-nav-card">
          <div className={`account-nav-item${selected === 'orders' ? ' selected' : ''}`} onClick={() => onNav && onNav('orders')}>
            <FontAwesomeIcon icon={faTicketAlt}/> Mis Órdenes
          </div>
          <div className={`account-nav-item${selected === 'profile' ? ' selected' : ''}`} onClick={() => onNav && onNav('profile')}>
            <FontAwesomeIcon icon={faUser}/> Perfil
          </div>
          {/* <div className="account-nav-item disabled">
            <FontAwesomeIcon icon={faCog}/> Configuración
          </div> */}
          <div className="account-nav-item logout" onClick={() => onNav && onNav('logout')}>
            <FontAwesomeIcon icon={faSignOutAlt}/> Cerrar Sesión
          </div>
        </div>
      </div>
      <div className="account-layout-right">
        {children}
      </div>
    </div>
  );
} 